import { Globals } from '@bwoty-web/ui-kit';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import CabinListContainer from './containers/CabinListContainer';
import { createCabinListStore } from './redux/store/cabinListStore';

const initialState = window.__INITIAL_STATE_IW_CABIN_LIST__;
delete window.__INITIAL_STATE_IW_CABIN_LIST__;

if (initialState) {
  const cabinListStore = createCabinListStore(initialState);
  const { siteSettings } = initialState;

  const root = createRoot(document.getElementById('iw-cabin-list'));
  root.render(
    <Globals
      siteId={siteSettings?.siteId || 1}
      legacyMode={siteSettings?.legacyMode}
    >
      <Provider store={cabinListStore}>
        <CabinListContainer />
      </Provider>
    </Globals>,
  );
}
